export const ContestItem = {
    id: 0,
    visibility: 0,
    title: '',
    subTitle: '',
    contestCompanies:[],
    ctaText: '',
    ctaUrl: '',
    contestTypeId: 0,
    mediaId: null,
    media: null,
    content: '',
    order: 0
};